import { render } from "./vtoast.vue?vue&type=template&id=3f7cdebb"
import script from "./vtoast.vue?vue&type=script&lang=js"
export * from "./vtoast.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__